<template>
  <div class="h-100">
    <b-row
      slot="header"
      class="pt-1 h-100"
    >
      <b-col
        v-if="!previousCases.length"
        class="d-flex align-items-center justify-content-center text-center"
      >
        <span class="mt-3 is-italic">{{ $t('registry.cases.noPreviousCases') }}</span>
      </b-col>
      <b-col
        v-if="previousCases.length"
        cols="12"
        class="d-flex flex-column h-100"
      >
        <b-row>
          <b-col class="text-center mt-1">
            <span
              v-if="previousCases.length"
              class="previous-cases-header-title font-weight--medium primary-dark-color"
            >{{ $t('registry.cases.patientCases') }} ({{ previousCases.length }})</span>
          </b-col>
        </b-row>
        <b-row class="previous-cases-scroll-area">
          <div class="w-100 mx-1">
            <b-col
              v-for="item in previousCases"
              :key="item.id"
              lg="12"
              class="px-2 mt-2"
            >
              <b-button
                :key="casId"
                size="sm"
                block
                class="btn__outline"
                :class="{ 'active': casId === item.id }"
                @click="openCase(item)"
              >
                <span
                  v-tooltip="item.casCasenumber"
                  class="previas-truncate"
                >{{ item.casenumber }}</span>
              </b-button>
            </b-col>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
    name: 'PatientPreviousCases',
    props: {
        previousCases: { type: Array, required: true },
        casId: { type: Number }
    },
    methods: {
        async openCase(previousCase) {
            const navigationConfirmed =
                await this.$_confirmNavigationBecauseOfLaboratoryChange(previousCase.laboratory.labId)
            if (navigationConfirmed) {
                this.$router.push({
                    name: 'registryEditCase',
                    params: { id: previousCase.id }
                })
            }
        }
    }
}

</script>

<style scoped lang="scss">

    .case-pop-overflow {
        max-height: 120px;
        overflow-y: auto;
    }

    .previous-cases-header-title {
        font-size: font-size-type(font-size-small-2);
    }

    .previous-cases-header{
        border-bottom:3px solid vt-color(light-primary);
        height: 37px;
    }

    .previous-cases-btn{
        background-color: rgba(255, 255, 255, 0.3);
        border-color: vt-color(primary);
        /* color: #707070; */
        color: vt-color(primary);
        transition: 0.4s;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
    }

    .previous-cases-btn:hover{
        background-color: vt-color(light-primary);
        color: #707070;
        border-color: rgba(0, 0, 0, 0.125);
    }

    .previous-cases-btn:active,
    .previous-cases-btn:focus,
    .previous-cases-btn.active{
        background-color: vt-color(primary) !important;
        border-color: transparent !important;
        color: #FFF;
    }

    .previous-active-btn:hover{
        background-color: rgba(0, 0, 0, 0.4);
        border-color: transparent;
        color: #FFF;
    }

    .previous-success{
        color: #40c6c2;
    }

    .previous-danger{
        color: #fc6274;
    }

</style>
